import { Pipe, PipeTransform } from '@angular/core';
import { DrawerNmdProductDto } from '../../../core/services/GPRMV1Service.Generated';

@Pipe({
    name: 'amountCalculation',
    standalone: false
})
export class AmountCalculationPipe implements PipeTransform {

  transform(value: string | number, addedElementAmount: number): number {
    return addedElementAmount ? this.amountParsing(value) * addedElementAmount : addedElementAmount;
  }

  amountParsing(amountValue: any): number {
    const amount: string = typeof amountValue === 'string' ? amountValue : '' + amountValue;
    return parseFloat(amount.replace(',', '.')) || 0;
  }


}
